import React, { useState } from 'react';
import { Typography, TextField, Button, Box } from '@mui/material';
import { MailOutline, LockOutlined, AccountCircle, Login } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { startLoginEmailPassword } from '../../../actions/auth';
import { HeaderTracking } from '../componentsLanding/HeaderTracking';

{/** TextInputField Component for input fields */}
const TextInputField = ({ label, type, value, onChange, startIcon, onKeyDown }) => (
  <TextField
    label={label}
    fullWidth
    margin="normal"
    type={type}
    value={value}
    onChange={onChange}
    onKeyDown={onKeyDown}
    InputProps={{
      startAdornment: startIcon,
      sx: { color: '#fff' },
    }}
    InputLabelProps={{
      sx: { color: '#fff' },
    }}
    sx={{
      '& .MuiOutlinedInput-root': {
        '& fieldset': { borderColor: '#fff' },
        '&:hover fieldset': { borderColor: '#fff' },
        '&.Mui-focused fieldset': { borderColor: '#fff' },
        '& input:-webkit-autofill': {
          WebkitBoxShadow: '0 0 0 1000px #143F6C inset',
          WebkitTextFillColor: '#fff',
        },
      },
      '& .MuiInputLabel-root': {
        color: '#fff',
        '&.Mui-focused': { color: '#fff' },
      },
    }}
  />
);

{/** LoginForm Component for the login form */}
const LoginForm = ({ handleLogin, email, setEmail, password, setPassword }) => (
  <Box
    component="form"
    sx={{
      textAlign: 'center',
      backgroundColor: '#143F6C',
      color: '#fff',
      width: '60%',
      padding: '20px',
      borderRadius: '10px',
    }}
  >
    <TextInputField
      label="Correo electrónico"
      type="email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      startIcon={<MailOutline sx={{ color: '#fff', marginRight: 2 }} />}
      onKeyDown={({ key }) => key === 'Enter' && handleLogin()}
    />
    <TextInputField
      label="Contraseña"
      type="password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      startIcon={<LockOutlined sx={{ color: '#fff', marginRight: 2 }} />}
      onKeyDown={({ key }) => key === 'Enter' && handleLogin()}
    />
    <Button
      variant="contained"
      color="success"
      sx={{
        mt: 2,
        width: 'fit-content',
        '&:hover': { color: '#fff' },
      }}
      startIcon={<AccountCircle />}
      onClick={handleLogin}
    >
      Iniciar sesión
    </Button>
  </Box>
);

{/** LeftSection Component for the left side of the login page */}
const LeftSection = () => (
  <Box
    sx={{
      flex: 1,
      backgroundColor: 'rgba(240, 240, 240, 0.8)',
      color: '#143F6C',
      padding: 2,
      borderRadius: '5px',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      flexDirection: 'column',
    }}
  >
    <Typography
      sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}
      variant="h2"
      component="h2"
      gutterBottom
    >
      Iniciar sesión <Login sx={{ fontSize: 40, marginLeft: 2 }} />
    </Typography>
    <Typography variant="body1" sx={{ mt: 2, fontSize: '1.5rem' }}>
      Bienvenido de vuelta. Por favor, inicia sesión con tu cuenta.
    </Typography>
  </Box>
);

{/** LoginTracking Component for the main login tracking page */}
export const LoginTracking = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();

  {/** Handle login action */}
  const handleLogin = () => {
    dispatch(startLoginEmailPassword(email, password));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        pt: '50px',
        position: 'fixed',
        top: '0',
        width: '100%',
        backgroundImage:
          "url('https://images.pexels.com/photos/259756/pexels-photo-259756.jpeg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <HeaderTracking />
      <Box sx={{ display: 'flex', maxWidth: '90%' }}>
        <LeftSection />
        <Box sx={{ width: 32 }} />
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            padding: 2,
          }}
        >
          <LoginForm
            handleLogin={handleLogin}
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
          />
        </Box>
      </Box>
    </Box>
  );
};
